import React, { useEffect } from "react"
import MFeedMasonry from "../blocks/m_feed_masonry"
import MScienceCarousel from "../blocks/m_science_carousel"
import MHeroCollectionSlider from "../blocks/m_hero_collection_slider"
import MHighlightCarousel from "../blocks/m_highlight_carousel"
import MCardGrid from "../blocks/m_cardgrid"
import DfbSpinner from "../ui-kit/dfb_spinner"

import useRemoteCollectionHandler from "../../hooks/useRemoteCollectionHandler"

const MMultiFormatStreamRemote = ({ data }) => {
  const { uid, headline, subheadline } = data
  const {
    collectionForPage,
    hasNextPage,
    totalCount,
    availableFilterOptions,
    setSelectedFilterOptions,
    handleNextPage,
  } = useRemoteCollectionHandler(data)

  useEffect(() => {
    if (
      collectionForPage &&
      collectionForPage.length &&
      window.upgradeAllBehaviours
    ) {
      // ensure grid and images are initialized by ui kit
      window.upgradeAllBehaviours()
    }
  }, [collectionForPage])

  useEffect(() => {
    if (availableFilterOptions && window.upgradeAllBehaviours) {
      // ensure grid and images are initialized by ui kit
      window.upgradeAllBehaviours()
    }
  }, [availableFilterOptions])

  // loading state: totalCount has its initial null value
  if (totalCount === null) {
    return (
      <section className="m-Error">
        <div className="m-Error-wrapper">
          <div className="m-Error-container">
            <div className="m-Error-content">
              <DfbSpinner type="continuous" autoLoop={true} />
              <br />
              <br />
              <br />
              <p className="m-Error-text">Daten werden geladen …</p>
            </div>
          </div>
        </div>
      </section>
    )
  }

  // empty result state: totalCount is zero
  if (totalCount === 0) {
    return (
      <section
        className="m-Empty"
        data-info={`MultiFormatStream: empty remote collection in component ${uid}`}
      ></section>
    )
  }

  // error result state: totalCount is undefined
  if (totalCount === undefined) {
    return (
      <section
        className="m-Empty"
        data-info={`MultiFormatStream: remote collection request failed in component ${uid}`}
      ></section>
    )
  }

  const stream_type = "m-cardgrid"
  //const stream_type = "m-feed-masonry"

  switch (stream_type) {
    case "m-feed-masonry": {
      return (
        <MFeedMasonry
          key={uid}
          collectionForPage={collectionForPage}
          hasNextPage={hasNextPage}
          totalCount={totalCount}
          availableFilterOptions={availableFilterOptions}
          setSelectedFilterOptions={setSelectedFilterOptions}
          handleNextPage={handleNextPage}
          data={data}
        />
      )
    }
    case "m-cardgrid": {
      return (
        <MCardGrid
          key={uid}
          collectionForPage={collectionForPage}
          hasNextPage={hasNextPage}
          totalCount={totalCount}
          availableFilterOptions={availableFilterOptions}
          setSelectedFilterOptions={setSelectedFilterOptions}
          handleNextPage={handleNextPage}
          data={data}
        />
      )
    }
    case "m_science_carousel": {
      return (
        <MScienceCarousel
          key={uid}
          data={{
            uid: uid,
            headline: headline,
            collection: collectionForPage,
          }}
        />
      )
    }
    case "m_highlight_carousel": {
      return (
        <MHighlightCarousel
          key={uid}
          data={{
            uid: uid,
            headline: headline,
            find_item_image: true,
            collection: collectionForPage,
          }}
        />
      )
    }
    case "m_hero_collection_slider": {
      return (
        <MHeroCollectionSlider
          key={uid}
          data={{
            uid: uid,
            collection: collectionForPage,
          }}
        />
      )
    }
    default: {
      return (
        <div>
          MMultiFormatStreamRemote with layout "{stream_type}" not implemented.
        </div>
      )
    }
  }
}

export default MMultiFormatStreamRemote
